// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"497":"039c6362","727":"0ca616d0"}[chunkId] + ".chunk.css";
};